<template>
  <v-card class="card-shadow mt-4 border-radius-xl">
    <v-card-title class="pb-0 d-flex align-center px-4 pt-4">
      <h6 class="mb-0 text-h6 text-typo font-weight-bold">聯絡資訊</h6>
      <v-spacer></v-spacer>
      <template v-if="!isCreateMode">
        <template v-if="!edit">
          <v-btn icon @click="startEdit" :ripple="false">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <template v-else>
          <v-btn icon class="mr-2" @click="cancelEdit" :ripple="false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-btn icon :loading="saving" @click="submit" :ripple="false">
            <v-icon color="red">mdi-content-save</v-icon>
          </v-btn>
        </template>
      </template>
    </v-card-title>
    <v-card-text class="px-4 pb-4">
      <v-row>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >聯絡城市</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.contact_city || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.contact_city"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >聯絡行政區</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.contact_region || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.contact_region"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >聯絡地址</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.contact_address || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.contact_address"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >聯絡人</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.contact_name || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.contact_name"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >聯絡人手機</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">
                {{ companyData.contact_mobile_country_code || "" }}
                {{ companyData.contact_mobile || "暫無資料" }}
              </v-list-item-title>
              <v-row v-else no-gutters>
                <v-col cols="4" class="pr-2">
                  <v-text-field
                    v-model="form.contact_mobile_country_code"
                    dense
                    hide-details="auto"
                    placeholder="國碼"
                  ></v-text-field>
                </v-col>
                <v-col cols="8">
                  <v-text-field
                    v-model="form.contact_mobile"
                    dense
                    hide-details="auto"
                    placeholder="號碼"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >網站</v-list-item-subtitle
              >
              <v-list-item-title v-if="!edit" class="text-typo">{{
                companyData.website || "暫無資料"
              }}</v-list-item-title>
              <v-text-field
                v-else
                v-model="form.website"
                dense
                hide-details="auto"
              ></v-text-field>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="12" md="6" v-if="false">
          <v-list-item class="px-0">
            <v-list-item-content>
              <v-list-item-subtitle class="text-sm text-body"
                >資料建立時間</v-list-item-subtitle
              >
              <v-list-item-title class="text-typo">{{
                formatDate(companyData.create_time) || "暫無資料"
              }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CompanyContactInfoWidget",
  props: {
    companyData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    isCreateMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      edit: this.isCreateMode,
      saving: false,
      form: {
        contact_address: "",
        contact_city: "",
        contact_region: "",
        contact_name: "",
        contact_mobile_country_code: "+886",
        contact_mobile: "",
        website: "",
      },
    };
  },
  watch: {
    companyData: {
      handler() {
        this.resetForm();
      },
      immediate: true,
      deep: true,
    },
    form: {
      handler(newVal) {
        // In create mode, emit changes immediately
        if (this.isCreateMode) {
          this.$emit("save", newVal, () => {});
        }
      },
      deep: true,
    },
  },
  methods: {
    resetForm() {
      this.form = {
        contact_address: this.companyData.contact_address || "",
        contact_city: this.companyData.contact_city || "",
        contact_region: this.companyData.contact_region || "",
        contact_name: this.companyData.contact_name || "",
        contact_mobile_country_code:
          this.companyData.contact_mobile_country_code || "+886",
        contact_mobile: this.companyData.contact_mobile || "",
        website: this.companyData.website || "",
      };
    },
    startEdit() {
      this.edit = true;
      this.resetForm();
    },
    cancelEdit() {
      this.edit = false;
      this.resetForm();
    },
    submit() {
      if (this.saving) return;
      this.saving = true;
      const payload = { ...this.form };
      this.$emit("save", payload, (ok) => {
        this.saving = false;
        if (ok) this.edit = false;
      });
    },
    formatDate(dateString) {
      if (!dateString) return "暫無資料";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "無效日期";
      return date.toLocaleDateString("zh-TW", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      });
    },
  },
};
</script>
